import axios from 'src/api/Api';
import {
    GET_ANNOUNCEMENTS_SUCCESS,
    GET_ANNOUNCEMENTS_FAILURE,
} from '../actions';
import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* getAnnouncements() {
    const url = `/occ/v2/${localStorage.getItem('baseSiteId')}/calendar/announcements`;

    try {
        const result = yield axios.get(url).then((response) => response.data);
        yield put({ type: GET_ANNOUNCEMENTS_SUCCESS, payload: result });
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: {}
        });
        yield put({
            type: GET_ANNOUNCEMENTS_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
